import { IconButton, Tooltip } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

// The second invoice link, beside the default one, for a tenant that uses a ServiceTitan
// Enterprise Hub (AB#420). Renders nothing without a URL -- invoiceUrls() only returns one for a
// validated EH host.
//
// stopPropagation is load-bearing: both grids open the default link from onCellClick on the whole
// cell, so without it a click here would open both tabs.
const EnterpriseHubLink = ({ href }) =>
  href ? (
    <Tooltip title="Open in Enterprise Hub">
      <IconButton
        component="a"
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        size="small"
        color="primary"
        aria-label="Open in Enterprise Hub"
        onClick={(e) => e.stopPropagation()}
      >
        <OpenInNewIcon fontSize="inherit" />
      </IconButton>
    </Tooltip>
  ) : null;

export default EnterpriseHubLink;
